<template>
    <div id="container" class="webzine">
        <div id="contents">
            <div class="wz_layout">
                <article-header></article-header>
                <div style="flex-direction: column; align-items: center;">
                    <el-row>
                        <el-col v-for="article in articleList"
                                :key="article.article_id"
                                :span="8"
                                style="padding:20px 15px; cursor:pointer;" >
                            <div        @click="moveArticle(article)">
                                <img style="width: 100%;" alt="기사 메인 이미지"
                                    :src="getMainImgUrl(article)">
                            </div>
                            <div style="padding:7px">
                                <span style="font-size: 17px; font-weight: 700;">{{article.article_title}}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <div style="padding: 20px 0 40px 0; text-align: center;">
                        <el-pagination
                            small
                            @current-change="getArticleListHandle"
                            layout="prev, pager, next"
                            :page-count="11"
                            :page-size="numOfRow"
                            :current-page.sync="pageNo"
                            :total="articleTotal">
                        </el-pagination>
                    </div>
                </div>
                <div class="wz_side">   
                    <web-zine-list-toc
                    @selectCategory="selectCategory"
                    @findArticle="findArticle"
                    :webzine_category_code="webzine_category_code"/>
                </div>
            </div>
        </div>
    </div>
    <!-- <el-container style="display: flex; overflow-y: hidden; height:100%;"
                 class="wz_cont">
        <div style="position: relative; overflow: auto; flex:1;">
            <div style="position: absolute; width: 100%;">
                <el-row type="flex" justify="center"
                        style="flex-direction: column; align-items: center;">
                    <el-col :xl="19" :lg="23" :md="22"
                            style="display: flex; flex-direction: column">
                        <div>
                            <web-zine-view-header></web-zine-view-header>
                        </div>
                        <div>
                            <el-row>
                                <el-col v-for="article in articleList"
                                        :key="article.article_id"
                                        :span="8"
                                        style="padding:20px 15px; cursor:pointer;" >
                                    <div        @click="moveArticle(article)">
                                        <img style="width: 100%;" alt="기사 메인 이미지"
                                            :src="getMainImgUrl(article)">
                                    </div>
                                    <div>
                                        <span style="font-size: 14px; font-weight: 300;">{{article.article_title}}</span>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div style="padding: 20px 0 40px 0; text-align: center;">
                            <el-pagination
                                small
                                @current-change="getArticleListHandle"
                                layout="prev, pager, next"
                                :page-count="11"
                                :page-size="numOfRow"
                                :current-page.sync="pageNo"
                                :total="articleTotal">
                            </el-pagination>
                        </div>
                    </el-col>

                </el-row>

            </div>

        </div>
        <div style="max-width: 480px; display: flex;"
             class="hidden-md-and-down">
            <web-zine-list-toc
                @selectCategory="selectCategory"
                @findArticle="findArticle"
                :webzine_category_code="webzine_category_code"/>
        </div>

    </el-container> -->
</template>

<script>
import WebZineListToc from "@/components/WebZineListToc";
import ArticleHeader from "@/components/ArticleHeader";
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
    name: "WebZineListMain",
    components: {ArticleHeader, WebZineListToc},
    mounted() {
        this.setSelectedWebZineId('all');
        this.getArticleListHandle();
    },
    computed: {
        ...mapGetters('webzineView', [
            'articleList',
            'articleTotal'
        ])
    },
    data(){
        return {
            pageNo: 1,
            numOfRow : 9,
            webzine_category_code: 'all'
        }
    },
    methods:{
        ...mapMutations('webzineView', [
            'setSelectedWebZineId'
        ]),
        ...mapActions('webzineView', [
            'getArticleList'
        ]),
        selectCategory(webzine_category_code){
          this.webzine_category_code =   webzine_category_code;
          this.getArticleListHandle();
        },

        findArticle(article_title){
            window.console.log(article_title);
            const loading = this.$cmmLoading();
            const param = this.getArticleParam(article_title);

            this.getArticleList(param)
                .catch(() => {
                    this.$errorMessage('기사 정보 중에 오류가 발생했습니다.');
                })
                .finally(() => {
                    loading.close();
                })
        },

        getArticleListHandle() {
            const loading = this.$cmmLoading();
            const param = this.getArticleParam('');

            this.getArticleList(param)
                .catch(() => {
                    this.$errorMessage('기사 정보 중에 오류가 발생했습니다.');
                })
                .finally(() => {
                    loading.close();
                })
        },

        getArticleParam(article_title){

            const param = {
                pageNo: this.pageNo,
                numOfRow: this.numOfRow,
                webzine_category_code : '',
            };

            if(this.webzine_category_code !== 'all'){
                param.webzine_category_code = this.webzine_category_code;
            }
            if(article_title){
                param.article_title = article_title;
            }
            return param
        },

        getMainImgUrl(article){
            if(article.mainImgFile){
                return [
                    this.$baseURL
                    , 'image' + article.mainImgFile.server_path
                    , article.mainImgFile.new_name
                ].join('/');
            }else{
                return '';
            }
        },

        moveArticle(article){
            const articleId = article.article_id;
            const webzineId = article.webzine_id;
            this.setSelectedWebZineId(webzineId);
            const url = `/publish/${webzineId}/articles/${articleId}`;

            window.console.log(url);
            this.$router.push(url);
        }
    }
}
</script>

<style scoped>

</style>
